import Banner from "@components/Banner";
import Breadcrumbs from "@components/Breadcrumbs";
import Footer from "@components/Footer";
import Header from "@components/Header";
import StayInspired from "@components/Home/StayInspired";
import AdditionalInfo from "@components/Wellness/AdditionalInfo";
import Gallery from "@components/Wellness/Gallery";
import Intro from "@components/Wellness/Intro";
import Offers from "@components/Wellness/Offers";
import Stories from "@components/Wellness/Stories";
import Facilities from "@components/Wellness/Tabs/Facilities";
import WellbeingCentre from "@components/Wellness/Tabs/WellbeingCentre/WellbeingCentre";
import WellnessTabs from "@components/Wellness/Tabs/WellnessTabs";
import { useLocomotiveContext } from "@providers/LocomotiveProvider";
import { usePageContext } from "@providers/PageProvider";
import { useRouteContext } from "@providers/RouteProvider";
import { useTranslationContext } from "@providers/TranslationProvider";
import helper, { wellnessPage } from "@utils/helper";
import { useEffect, useState } from "react";
import _ from "lodash";
enum TabsKey {
  WellbeingCentre = "WellbeingCentre",
  Facilities = "Facilities",
}

const View = () => {
  const { router } = useRouteContext();
  const [activeTab, setActiveTab] = useState<TabsKey>(TabsKey.WellbeingCentre);
  const { i18n } = useTranslationContext();
  const { scroll } = useLocomotiveContext();
  const { pageData, storyArticles, offers, hotel } = usePageContext();

  const banner = helper.formatBanner(pageData[activeTab]);
  const footer = helper.renderDetailsFooter(hotel);
  useEffect(() => {
    if (router?.query?.wellnessTab) {
      setActiveTab(router?.query?.wellnessTab);
      // location.href = "#wellnessTabs";
      if (scroll) {
        // 164 is height of header
        scroll.scrollTo("#wellnessTabs", { duration: 200, offset: -174 });
      }
    }
  }, [router?.query, scroll]);

  const intro = wellnessPage.formatIntro(pageData[activeTab]);
  const wellbeingCentre = wellnessPage.formatWellbeingCentre(
    pageData[activeTab]
  );
  const articlesWellbeing = wellnessPage.formatArticles(pageData[activeTab]);
  const facilities = wellnessPage.formatFacilities(pageData[activeTab]);
  const gallery: any = wellnessPage.formatGallery(pageData[activeTab]);
  const additional: any = wellnessPage.formatAdditional(pageData[activeTab]);
  const stories: any = {
    ...wellnessPage.formatStories(pageData[activeTab]),
    articles: wellnessPage.formatWellnessStories(storyArticles),
  };
  const offersData = {
    ...wellnessPage.formatOffers(pageData[activeTab]),
    offers: wellnessPage.formatWellnessOffers(offers),
  };
  return (
    <div className="bg-black" data-scroll-container>
      <Header />
      <Banner image={_.get(banner, "image")} title={_.get(banner, "title")} />
      <Breadcrumbs data={router.breadcrumbs("wellness", {})} />
      <Intro data={intro} />
      <WellnessTabs
        activeTab={activeTab}
        onChange={(key) => setActiveTab(key as TabsKey)}
        tabs={[
          {
            key: TabsKey.WellbeingCentre,
            name: i18n.t("Wellness.wellbeingCentre.wellbeingCentre"),
            content: (
              <WellbeingCentre
                data={wellbeingCentre}
                articles={articlesWellbeing}
              />
            ),
          },
          {
            key: TabsKey.Facilities,
            name: i18n.t("Wellness.facilities.facilities"),
            content: <Facilities data={facilities} activeTab={activeTab} />,
          },
        ]}
      />
      <Gallery data={gallery} />
      <AdditionalInfo data={additional} />
      <Stories data={stories} />
      <Offers data={offersData} />
      <StayInspired />
      <Footer
        data={{
          name: footer.name,
          address: footer.address,
          email: footer.email,
        }}
      />
    </div>
  );
};

export default View;
